import { useCallback } from 'react';

import { useFormCallback } from 'apps/shared/scripts/hooks';

import { SecuritySettingsForm } from '../../components';
import { SecuritySettingsFormValues } from '../../components/SecuritySettingsForm';
import { useChangePassword } from '../../hooks';

const SecuritySettingsFormContainer = () => {
  const { changePassword, loading: isChanging } = useChangePassword();

  const { onSuccess, onError } = useFormCallback();

  const onSave = useCallback(
    async (data: SecuritySettingsFormValues) => {
      try {
        const { error, result } = await changePassword(
          data.currentPassword,
          data.newPassword,
        );
        if (!result || error.code) {
          throw new Error(error.message);
        }
        onSuccess({ message: 'Success! Password has been updated' });
      } catch (e) {
        onError(e);
        throw e;
      }
    },
    [changePassword, onError, onSuccess],
  );

  return <SecuritySettingsForm isSubmitting={isChanging} onSubmit={onSave} />;
};

SecuritySettingsFormContainer.displayName = 'SecuritySettingsFormContainer';

export default SecuritySettingsFormContainer;
